import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import ReactSelect from '../../../../app/modules/UI/ReactSelect'
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
const initialValues = {
    allSubstructures: '',
    structureId: '',

}

export default function Create(props) {
    const {
        show,
        onHide,
        onLogLocalRows,
        skip,
        take,
        orderBy,
        sortField,
        structureId,
        id
    } = props
    const [isError, setIsError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [chooseStructureIdOption, setChooseStructureIdOption] = useState([])

    const [department, setDepartment] = useState()
    const [directorate, setDirectorate] = useState()
    const [branch, setBranch] = useState()
    const [division, setDivision] = useState()
    const [structureType, setStructureType] = useState()

    const [chooseDepartmentOption, setChooseDepartmentOption] = useState([])
    const [chooseDirectorateOption, setChooseDirectorateOption] = useState([])
    const [chooseBranchOption, setChooseBranchOption] = useState([])
    const [chooseDivisionOption, setChooseDivisionOption] = useState([])
    const [chooseStructureTypeOption, setChooseStructureTypeOption] = useState([])

    const CreateSchema = Yup.object().shape({
        structureId: Yup.string().required('StruKtur ID tələb olunur.'),
    })

    const getInputClasses = (filedName) => {
        if (formik.touched[filedName] && formik.errors[filedName]) {
            return true
        }
        if (formik.touched[filedName] && !formik.errors[filedName]) {
            return false
        }

        return false
    }

    const onPostGroup = (values, resetForm, setSubmitting) => {
        setIsLoading(true)

        const group = {
            structureId: values.structureId ? values.structureId : "",
            allSubstructures: values.allSubstructures ? true : false,

        }
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}structure-local/device-place/${id}?allSubstructures=${group.allSubstructures}&structureId=${group.structureId}`,
            data: group,

        })
            .then((res) => {
                onLogLocalRows(orderBy, sortField, skip, take)
                setSubmitting(false)
                resetForm()
                onHide(false)
                setIsLoading(false)
            })
            .catch((err) => {
                let message =
                    typeof err.response !== 'undefined'
                        ? err.response.data.message
                        : err.message
                setIsError(message)
                setIsLoading(false)
            })
    }

    const formik = useFormik({
        initialValues,
        validationSchema: CreateSchema,
        onSubmit: (values, { resetForm, setSubmitting }) => {
            onPostGroup(values, resetForm, setSubmitting)
        },
    })

    const resetForm = () => {
        onHide()
        formik.resetForm()
    }

    useEffect(() => {
        setIsError('')
    }, [show])



    function handleChangeStructure(value) {
        setChooseStructureIdOption(value)
        formik.setFieldValue('structureId', value ?  value.value : "")

        axios
            .get(
                `${process.env.REACT_APP_API_URL}structure/select?id=${value ?  value.value : ""}`,
            )
            .then((res) => {
                const displayTypes = res.data.map(({ id, name, type }) => ({
                    value: id,
                    label: name,
                    type: type,
                }))

                const newDepartmentItem = displayTypes.filter((obj) => {
                    return obj.type === 'DEPARTMENT'
                })
                const newDirectorateItem = displayTypes.filter((obj) => {
                    return obj.type === 'DIRECTORATE'
                })
                const newBranchItem = displayTypes.filter((obj) => {
                    return obj.type === 'BRANCH'
                })
                const newDivisionItem = displayTypes.filter((obj) => {
                    return obj.type === 'DIVISION'
                })
                const newStructureTypeItem = displayTypes.filter((obj) => {
                    return obj.type === 'STRUCTURE_TYPE'
                })
                setDepartment(newDepartmentItem)
                setDirectorate(newDirectorateItem)
                setBranch(newBranchItem)
                setDivision(newDivisionItem)
                setStructureType(newStructureTypeItem)

                setChooseDirectorateOption(null)
                setChooseBranchOption(null)
                setChooseDivisionOption(null)
                setChooseDepartmentOption(null)
                setChooseStructureTypeOption(null)
            })
    }

    const handleChangeDirectorateNames = (value) => {
        setChooseDirectorateOption(value)
        formik.setFieldValue('structureId', value ? value.value :"")
    
        axios
          .get(
            `${process.env.REACT_APP_API_URL}structure/select?id=${value ? value.value :""}`,
          )
          .then((res) => {
            const displayTypes = res.data.map(({ id, name, type }) => ({
              value: id,
              label: name,
              type: type,
            }))
           const newDepartmentItem = displayTypes.filter((obj) => {
              return obj.type === 'DEPARTMENT'
            })
            const newBranchItem = displayTypes.filter((obj) => {
              return obj.type === 'BRANCH'
            })
            const newDivisionItem = displayTypes.filter((obj) => {
              return obj.type === 'DIVISION'
            })
            const newStructureTypeItem = displayTypes.filter((obj) => {
              return obj.type === 'STRUCTURE_TYPE'
            })
            setDepartment(newDepartmentItem)
            setBranch(newBranchItem)
            setDivision(newDivisionItem)
            setStructureType(newStructureTypeItem)
    
            setChooseDepartmentOption(null)
            setChooseBranchOption(null)
            setChooseDivisionOption(null)
            setChooseStructureTypeOption(null)
          })
      }
    
      const handleChangeDepartmentNames = (value) => {
        setChooseDepartmentOption(value)
        formik.setFieldValue('structureId', value ? value.value :"")
    
        axios
          .get(
            `${process.env.REACT_APP_API_URL}structure/select?id=${value ? value.value :""}`,
          )
          .then((res) => {
            const displayTypes = res.data.map(({ id, name, type }) => ({
              value: id,
              label: name,
              type: type,
            }))
    
       
            const newBranchItem = displayTypes.filter((obj) => {
              return obj.type === 'BRANCH'
            })
            const newDivisionItem = displayTypes.filter((obj) => {
              return obj.type === 'DIVISION'
            })
            const newStructureTypeItem = displayTypes.filter((obj) => {
              return obj.type === 'STRUCTURE_TYPE'
            })
            setBranch(newBranchItem)
            setDivision(newDivisionItem)
            setStructureType(newStructureTypeItem)
    
            setChooseBranchOption(null)
            setChooseDivisionOption(null)
            setChooseStructureTypeOption(null)
          })
      }
    

    const handleChangeBranchNames = (value) => {
        setChooseBranchOption(value)
        formik.setFieldValue('structureId', value ?  value.value : "")

        axios
            .get(
                `${process.env.REACT_APP_API_URL}structure/select?id=${value ?  value.value : ""}`,
            )
            .then((res) => {
                const displayTypes = res.data.map(({ id, name, type }) => ({
                    value: id,
                    label: name,
                    type: type,
                }))

                const newDivisionItem = displayTypes.filter((obj) => {
                    return obj.type === 'DIVISION'
                })
                const newStructureTypeItem = displayTypes.filter((obj) => {
                    return obj.type === 'STRUCTURE_TYPE'
                })
                setDivision(newDivisionItem)
                setStructureType(newStructureTypeItem)

                setChooseDivisionOption(null)
                setChooseStructureTypeOption(null)
            })
    }

    const handleChangeDivisionNames = (value) => {
        setChooseDivisionOption(value)
        formik.setFieldValue('structureId', value ?  value.value : "")

        axios
            .get(
                `${process.env.REACT_APP_API_URL}structure/select?id=${value ?  value.value : ""}`,
            )
            .then((res) => {
                const displayTypes = res.data.map(({ id, name, type }) => ({
                    value: id,
                    label: name,
                    type: type,
                }))

                const newStructureTypeItem = displayTypes.filter((obj) => {
                    return obj.type === 'STRUCTURE_TYPE'
                })
                setStructureType(newStructureTypeItem)
                setChooseStructureTypeOption(null)
            })
    }

    const handleChangeStructureTypeNames = (value) => {
        setChooseStructureTypeOption(value)
        formik.setFieldValue('structureId', value ? value ?  value.value : "" :"")
    }

    return (
        <Modal
            size="xl"
            aria-labelledby="create"
            centered
            className="modal pr-0"
            show={show}
            onHide={resetForm}
        >
            <form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title id="create">Əlavə et</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12 pl-4 pr-4">
                        <div className="row">

                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                id="allSubstructures"
                                                name="allSubstructures"
                                                value={formik.values.allSubstructures}
                                                error={getInputClasses('allSubstructures')}
                                                {...formik.getFieldProps('allSubstructures')}


                                            />
                                        }
                                        label="Alt strukturlar"
                                    />
                                </div>
                                {formik.touched.allSubstructures && formik.errors.allSubstructures ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.allSubstructures}</div>
                                    </div>
                                ) : null}

                            </div>
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />

                                    <ReactSelect
                                        suggestions={structureId}
                                        handleChangeSingle={(value) => handleChangeStructure(value)}
                                        single={chooseStructureIdOption}
                                        label="Şirkət  seçin"
                                        placeholder="Şirkət seçin"
                                        inputId="structureId"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                           
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />

                                    <ReactSelect
                                        suggestions={directorate}
                                        handleChangeSingle={(value) =>
                                            handleChangeDirectorateNames(value)
                                        }
                                        single={chooseDirectorateOption}
                                        label="Direktorluq  seçin"
                                        placeholder="Direktorluq seçin"
                                        inputId="Directorate"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />

                                    <ReactSelect
                                        suggestions={department}
                                        handleChangeSingle={(value) =>
                                            handleChangeDepartmentNames(value)
                                        }
                                        single={chooseDepartmentOption}
                                        label="Departament  seçin"
                                        placeholder="Departament seçin"
                                        inputId="department"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />
                                    <ReactSelect
                                        suggestions={branch}
                                        handleChangeSingle={(value) =>
                                            handleChangeBranchNames(value)
                                        }
                                        single={chooseBranchOption}
                                        label="Şöbə  seçin"
                                        placeholder="Şöbə seçin"
                                        inputId="branch"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />
                                    <ReactSelect
                                        suggestions={division}
                                        handleChangeSingle={(value) =>
                                            handleChangeDivisionNames(value)
                                        }
                                        single={chooseDivisionOption}
                                        label="Bölmə seçin"
                                        placeholder="Bölmə seçin"
                                        inputId="division"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <input
                                        type="text"
                                        name="structureId"
                                        hidden
                                        {...formik.getFieldProps('structureId')}
                                    />
                                    <ReactSelect
                                        suggestions={structureType}
                                        handleChangeSingle={(value) => handleChangeStructureTypeNames(value)}
                                        single={chooseStructureTypeOption}
                                        label="Struktur növü  seçin"
                                        placeholder="Struktur növü seçin"
                                        inputId="Struktur növü"
                                    />
                                </div>
                                {formik.touched.structureId && formik.errors.structureId ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.structureId}
                                        </div>
                                    </div>
                                ) : null}
                            </div>


                            {isError && (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                                        {isError}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={() => {
                            onHide(false)
                            formik.resetForm()
                        }}
                    >
                        Ləğv et
                    </Button>
                    <Button type="submit" className={isLoading ? 'px-9' : ''}>
                        <span>Əlavə et</span>
                        {isLoading && <span className="ml-3 spinner spinner-white"></span>}
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}
